module.exports = __webpack_public_path__ + "static/bcalogo-fbb4c1a3e817d868667df923ac98884e.png";